"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

$(document).on("backbutton", function (event, data) {
  // Define the platform back button to do whatever the onclick of the "gui back button" does, otherwise do
  // what's in the alternate back link, if any
  // else ignore the back button.
  var back_link = $(".ui-page-active [data-link-type='back-link']");
  var alt_back_link = $(".ui-page-active [data-alt-back-link='back-link']");

  if (back_link.length > 0) {
    back_link.click();
  } else if (alt_back_link.length > 0) {
    alt_back_link.click();
  } else {
    // Would like to add a back button action to return to the android home screen
    // but that doesn't seem to be possible -- GS

    //Do nothing if there is no back button
  }
});

$(window).on("pagechange", function (event, data) {
  orientationUpdate();
  $(window).resize();
});

$(window).on("pagebeforeshow", function (event, data) {
  if (!DelayedStart.started()) {
    return;
  }

  var name = event.target.id;
  if (name == "interviews") {
    Interviews.interviewMenu();
  } else if (name == "main") {
    MainPage.init();
  } else if (name == "users") {
    UsersPage.init();
  } else if (name == "sync") {
    SyncPage.init();
  } else if (name == "register") {
    RegisterPage.init();
  } else if (name == "settings") {
    SettingsPage.init();
  } else if (name == "stats") {
    setTimeout(function () {
      StatsController.drawStats();
    }, 1);
  } else if (name == "vitals") {
    VitalsPage.init();
  } else if (name == "sos") {
    initSosPage();
  } else if (name == "video") {
    VideoPage.init();
  } else if (name == "consent") {
    ConsentPage.init();
  } else if (name == "about") {
    $(".app-version").text(mymobileAppVersion.displayVersion);
    $(".tm-version").text(mymobileAppVersion.tmVersion);
    $(".device-uuid").text(Store.getDeviceUUID());
    $(".build-version").text(mymobileAppVersion.buildVersion ? mymobileAppVersion.buildVersion : "");
    $(".build-date").text(mymobileAppVersion.buildDate);
    $(".activated-url:first").text(BaseUrlManager.baseUrl || mymobileConfig.mymobileUrl);

    if (mymobileConfig.enable_eu_info && mymobileConfig.showCEMark) {
      $(".booklet-image").show();
    } else {
      $(".booklet-image").hide();
    }

    if (mymobileConfig.enable_eu_info) {
      $(".eu-rep").show();
    } else {
      $(".eu-rep").hide();
    }

    if (mymobileConfig.showCEMark) {
      $(".ce-mark-image").show();
    } else {
      $(".ce-mark-image").hide();
    }
  } else if (name == "clear-data") {
    ClearDataPage.init();
  } else if (name == "login") {
    LoginPage.init();
  } else if (name == "devices") {
    ConnectedPage.init();
  } else if (name == 'device') {
    DevicePage.init();
  }
});

$(window).on("pageshow", function (event, data) {
  var stepId = $(event.target).data("step-id");

  if (stepId) {
    var step = Interviews.findStepById(stepId);
    if (step) {
      step.onShow();
    }
  }
});

$(window).on("pagebeforechange", function (event, data) {
  var toPage = data.toPage;

  if (typeof toPage == "string") {
    var pInf = toPage.split("#");
    toPage = "#" + pInf[pInf.length - 1];

    var resetPassword = toPage.lastIndexOf("#passwordreset", 0) === 0;
    var registration = toPage.lastIndexOf("#register", 0) === 0;

    if (resetPassword || registration) {
      toPage = "#register";
      var newKey = toPage.replace("#register", "").replace("#passwordreset", "");
      if (newKey != "") {
        RegisterPage.regKey = newKey;
        RegisterPage.resetPassword = resetPassword;
      }
    }

    if (data.options.fromPage.data('url') == 'vitals') {
      VitalsPage.reset();
    }
  }

  if (!DelayedStart.started()) {
    var gotoPage = DelayedStart.loadedFirstPage(toPage);
    if (typeof data.toPage == "string") {
      data.toPage = gotoPage;
    }
  } else if (typeof data.toPage == "string" && !Auth.loggedIn() && toPage != "#register" && toPage != "#users" && toPage != "#activatePendingPage") {
    data.toPage = "#login";
  }
});

var LoginPage = {

  setup: function setup() {
    $('#loginForm').on('submit', function (e) {
      e.preventDefault();LoginPage.login();return false;
    });
    $('#loginButton').bind('click', function (event) {
      event.preventDefault();LoginPage.login();return false;
    });
    $('#offlineButton').bind('click', function () {
      LoginPage.offline();
    });

    //hide everything but username & sign in
    if (mymobileConfig.hcn_login) {
      $('.normal-login').hide();
      $('.hcn-login').show();
    } else {
      $('.normal-login').show();
      $('.hcn-login').hide();
    }

    if (mymobileConfig.hcn_login && mymobileConfig.use_id_scanner && !inBrowser && deviceOS != 'iOS') {
      $('#scanIDCardButton-div').show();
    } else {
      $('#scanIDCardButton-div').hide();
    }
  },

  init: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var rememberedToken;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              IdleHandler.stop();

              $('input').val('');

              if ($('input[name="passwordInputField-clone"]').length == 0) {
                $('#passwordInputField').showPassword();
              } else {
                $('#passwordInputField').show();
                $('input[name="passwordInputField-clone"]').hide();
              }

              $('#showPasswordCheckbox').prop('checked', false);
              LoginPage.message(null);

              this.rememberedUser = false;

              if (!false) {
                _context.next = 17;
                break;
              }

              _context.next = 9;
              return SecureStore.get().checkRememberMe();

            case 9:
              rememberedToken = _context.sent;

              this.rememberedUser = rememberedToken != null;
              rememberedToken = null;

              if (this.rememberedUser) {
                $('#usernameInputField').val("•••••••••••••••");
                $('#passwordInputField').val("•••••••••••••••");
              }

              $("#rememberMeSection").show();
              $('#rememberMeCheckbox').prop('checked', this.rememberedUser);
              _context.next = 19;
              break;

            case 17:
              $("#rememberMeSection").hide();
              $('#rememberMeCheckbox').prop('checked', false);

            case 19:

              MainPage.syncNextLoad = true;

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init() {
      return _ref.apply(this, arguments);
    }

    return init;
  }(),

  setScannedId: function setScannedId(text) {
    $('#usernameInputField').val(text);
    if (text != "") {
      this.login();
    }
  },

  message: function message(text) {
    if (text == "" || text == null) $('#login-message-div').hide();else $('#login-message-div').text(text).show();
  },

  login: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this = this;

      var rememberMe, username, password, parameters, rememberedToken;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              rememberMe = $('#rememberMeCheckbox').prop('checked');
              username = $('#usernameInputField').val();
              password = $('#passwordInputField').val();
              parameters = {
                version: mymobileAppVersion.appVersion + (inBrowser ? "" : " OS/" + deviceOS + ":" + deviceOSVersion),
                browser: inBrowser,
                remember_me: rememberMe,
                device_uuid: Store.getDeviceUUID(),
                login_mode: "username/password"
              };


              if (mymobileConfig.hcn_login) {
                parameters.login_mode = "hcn";
              }

              if (!(rememberMe && this.rememberedUser && username.replace(/•/g, "") == "" && password.replace(/•/g, "") == "")) {
                _context2.next = 12;
                break;
              }

              _context2.next = 8;
              return SecureStore.get().checkRememberMe();

            case 8:
              rememberedToken = _context2.sent;

              parameters.remembered_token = rememberedToken;
              _context2.next = 15;
              break;

            case 12:
              parameters.username = username;
              parameters.password = password;
              $('.password-field').val('');

            case 15:

              //parameters.username = "test.shan.A1"
              //parameters.password = "!est.shan.A1"


              LoginPage.message($t("progress.logging_in"));

              postLoginAsync(parameters).then(function (res) {
                Auth.initSession(res.invocationResult['hub-info']);

                LoginPage.message($t("progress.logged_in"));

                finishLogin(rememberMe).then(function (res) {

                  if (mymobileConfig.consent.patient_consent_required && !Profile.consent_granted) {
                    openPage("consent");
                  } else openPage("main");
                }, function (err) {
                  console.log(err);LoginPage.message($t("errors.no_login"));
                });
              }, function (err) {
                if ((err.status == 404 || err.status == 400) && _this.rememberedUser) {
                  SecureStore.get().clearAllRememberMe();
                  $('#usernameInputField').val("");
                  $('.password-field').val('');
                  _this.rememberedUser = false;
                  $('#rememberMeCheckbox').prop('checked', false);
                }

                LoginPage.message(null);
                LoginPage.message(LoginPage.checkLoginError(err));
              });

            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function login() {
      return _ref2.apply(this, arguments);
    }

    return login;
  }(),

  checkLoginError: function checkLoginError(result) {
    var online = checkNetworkConnection();
    var errMess = null;
    try {
      errMess = result.responseJSON.invocationResult.errors.error;
    } catch (exp) {}

    if (errMess) {
      if (errMess == 'PatientIsNotActive') {
        return $t("errors.pat_not_active");
      } else if (errMess == 'AccountLocked') {
        return $t("errors.account_locked");
      } else {
        if (mymobileConfig.hcn_login) {
          return $t("errors.no_login_hcn");
        } else {
          return $t("errors.no_login");
        }
      }
    }

    return $t(online ? "errors.no_server" : "errors.no_connection");
  },

  clickRememberMe: function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(elem) {
      var _this2 = this;

      var newSetting, rememberedUserToken;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              newSetting = $(elem).prop('checked');
              _context3.next = 3;
              return SecureStore.get().checkRememberMe();

            case 3:
              rememberedUserToken = _context3.sent;

              if (!newSetting && rememberedUserToken != null) {

                ConfirmDialog.open(function (result) {
                  if (result) {
                    SecureStore.get().clearAllRememberMe();
                    $('#usernameInputField').val("");
                    $('.password-field').val('');
                    _this2.rememberedUser = false;
                    $('#rememberMeCheckbox').prop('checked', false);
                  } else {
                    $('#rememberMeCheckbox').prop('checked', true);
                  }
                });
              } else if (newSetting && rememberedUserToken == null) {

                SecureStore.get().getStoreAndValidate().then(function (resolve) {}, function (reject) {
                  $('#rememberMeCheckbox').prop('checked', false);
                });
              }

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function clickRememberMe(_x) {
      return _ref3.apply(this, arguments);
    }

    return clickRememberMe;
  }(),

  offline: function offline() {
    LoginPage.message(null);
    $(".generated-page").remove();

    //Enable messaging
    $("#main-messages").hide();

    Store.getAllSettings().then(function (settings) {
      var patientList = [];
      for (var i = 0; i < settings.length; i++) {
        if (settings[i].json.patientId && settings[i].json.patientName) {
          patientList.push(settings[i]);
        }
      }

      if (patientList.length == 0) {
        LoginPage.message($t("errors.no_offline"));
      } else if (patientList.length == 1) {
        Auth.initOffline(settings[0].json.patientId, settings[0].json.patientName, settings[0].json.monitorProfileId, {
          success: function success() {
            IdleHandler.start();openPage('main');
          },
          error: function error() {
            LoginPage.message($t("errors.no_offline"));
          }
        });
      } else {
        IdleHandler.start();
        openPage("users");
      }
    });
  }
};

var ClearDataPage = {

  init: function init() {
    this.fillCompletedInterviewsDataTable();
    this.fillPatientSettingsTable();
  },

  fillCompletedInterviewsDataTable: function fillCompletedInterviewsDataTable() {
    var tbody = $("#completed-interviews-table tbody");
    tbody.empty();
    for (var forDate in Interviews.completedTimes) {
      var ints = Interviews.completedTimes[forDate];
      for (var intId in ints) {
        var interv = ints[intId];
        for (var schedId in interv) {
          var compTable = interv[schedId];
          for (var i = 0; i < compTable.length; i++) {
            var interviewData = compTable[i];
            var row = $('<tr>');
            var startDate = new Date(Date.parse(interviewData.timeStarted));
            var finishDate = new Date(Date.parse(interviewData.timeFinished));
            row.append($('<td>').text(interviewData.title));
            row.append($('<td>').text($l(startDate)));
            row.append($('<td>').text($l(finishDate)));
            tbody.append(row);
          }
        }
      }
    }
  },

  fillPatientSettingsTable: function fillPatientSettingsTable() {
    var tbody = $("#saved-user-settings-table tbody");
    tbody.empty();
    var buttonTemplate = '<a href="#" style="padding:0;margin:0;" onclick="ClearDataPage.deleteSavedPatient({{patientid}});" data-role="button" data-icon="delete" data-iconpos="notext"/>';
    Store.getAllSettings().then(function (settings) {
      for (var i = 0; i < settings.length; i++) {
        if (settings[i].json.patientId) {
          var row = $('<tr>');
          var td = row.append($('<td style="padding:4px" >'));
          if (!Auth.offline() && Auth.loggedIn() && Auth.patientId() == settings[i].json.patientId) {
            td.append($(buttonTemplate.replace('{{patientid}}', settings[i].json.patientId)));
          } else {
            td.html("&nbsp");
          }
          row.append($('<td style="padding:4px" >').text(settings[i].json.patientName));
          tbody.append(row).trigger('create');
        }
      }
    });
  },

  deleteSavedPatient: function deleteSavedPatient(id) {
    Store.findSettings(id).then(function (settings) {
      if (settings && settings.length > 0) Store.deleteSettings(settings[0]);
      ClearDataPage.fillPatientSettingsTable();
    });
  }
};

var SyncPage = {

  init: function init() {
    checkNetworkConnection();
    setMainSyncStatus();
  },

  submit: function submit() {
    MainPage.clickSync();
  }
};

var MainPage = {
  syncNextLoad: false,
  loadingInterviews: false,

  init: function init() {
    checkNetworkConnection();
    this.updateDisplay();

    setMainSyncStatus();
    if (this.syncNextLoad) {
      setTimeout(function () {
        MainPage.clickSync();
      }, 1);

      this.syncNextLoad = false;
    }

    MainPage.appointmentsMenu();
    Interviews.pendingMenu();

    checkForAppUpdates();
  },

  openHelp: function openHelp() {
    if (inBrowser) {
      window.open(mymobileConfig.helpUrl, "_system");
    } else {
      window.open(mymobileConfig.mymobileUrl + "download.html?help=yes", "_system");
    }
  },

  updateDisplay: function updateDisplay() {
    var name = $("<div>").text(Auth.patientName()).html();
    $('#welcome-name').html($t("labels.welcome") + "<br/>" + name);

    if (deviceOS != 'iOS' && Profile.videoConferencingEnabled()) {
      $('#main-video').show();
    } else {
      $('#main-video').hide();
    }

    if (deviceOS == 'Android' && mymobileConfig.enable_myassist && Profile.myAssistEnabled()) {
      $('#main-sos').show();
    } else {
      $('#main-sos').hide();
    }

    //Enable messsaging
    if (mymobileConfig && mymobileConfig.secure_messaging && mymobileConfig.secure_messaging.enabled) {
      $("#main-messages").show();
    } else {
      $("#main-messages").hide();
    }

    if (Profile.unread_message_count > 0) {
      $('#main-messages #unread-message-notification').show();
      $('#messages-icon').attr('src', "css/images/icons-color/message-new.svg");
      $('#main-messages #unread-message-notification .unread-message-count').text(Profile.unread_message_count);
    } else {
      $('#main-messages #unread-message-notification').hide();
      $('#messages-icon').attr('src', "css/images/icons-color/message.svg");
      $('#main-messages #unread-message-notification .unread-message-count').text("0");
    }

    if (mymobileConfig.enable_latest_readings) {
      $('#main-vitals').show();
    } else {
      $('#main-vitals').hide();
    }

    if (mymobileConfig.enable_contact_carer) {
      $('#main-carer').show();
    } else {
      $('#main-carer').hide();
    }

    if (mymobileConfig.consent.patient_consent_required) {
      $('#main-consent').show();
    } else {
      $('#main-consent').hide();
    }

    $('#sign_in_out').text($t(Auth.offline() ? "menus.sign_in" : "menus.sign_out"));

    if (mymobileConfig.helpUrl == "") {
      $(".user-manual-link").hide();
    }
  },

  startAppointment: function startAppointment() {
    var apptId = $('#appointment-pending').data("appt-id");

    if (apptId) {
      VideoPage.startConference();
      MainPage.appointmentsMenu();
    } else {
      openMessagePopup($t("video.video_conference_is_pending"), '#appointment-pending');
    }
  },

  appointmentsMenu: function appointmentsMenu(fromTimer) {

    $('#appointment-pending').hide();
    var appt = Appointment.nextApptForPatient(parseInt(Auth.patientId()));

    if (appt != null && deviceOS != 'iOS' && Profile.videoConferencingEnabled()) {
      $('#appointment-pending').show();

      var dispItem = new AppointmentDisplayItem(appt, true);

      $('#appointment-pending .appt-time').text(dispItem.nextDateFromNow);
      $('#appointment-pending .appt-desc').text(dispItem.titleExtra);

      var imgSrc = "css/images/icons-color/clock.svg";
      if (dispItem.active) {
        imgSrc = "css/images/icons-color/ready.svg";
        $('#appointment-pending .appt-start-button').show();
        $('#appointment-pending').data("appt-id", dispItem.appointment_id);
      } else {
        $('#appointment-pending .appt-start-button').hide();
        $('#appointment-pending').data("appt-id", "");
      }

      $('#appointment-pending .appt-icon').attr("src", imgSrc);
    }

    orientationUpdate();
  },

  clickSync: function clickSync() {
    var self = this;

    if (Auth.offline()) {
      setMainSyncStatus();
    } else {
      MainPage.loadingInterviews = true;
      setMainSyncStatus();

      if (deviceOS == "iOS" && mymobileConfig.healthKitEnabled) {
        submitHealthkitData();
      }

      syncAllASync({ updateStatus: setMainSyncStatus }).then(function (res) {
        self.updateDisplay();

        MainPage.loadingInterviews = false;
        Store.setLastSyncDate();
        setMainSyncStatus();

        MainPage.appointmentsMenu();
        Interviews.pendingMenu();
        refreshNotifications();
        Store.clearAllGraphData();
        loadPrivacyPolicyFromStore();
      }, function (err) {
        self.updateDisplay();

        MainPage.loadingInterviews = false;
        setMainSyncStatus();
        var errs = $t("errors.sync_failure");
        if (err.status == 401) {
          Auth.goOffline();
          errs = $t("errors.sync_not_active");
        } else {
          try {
            errs = err.responseJSON.invocationResult.errors.error;
          } catch (exp) {}
        }
        $('.sync_summary').text(errs);
      });
    }
  },

  signInOut: function signInOut() {
    ConfirmSignOutDialog.open();
  },

  logOut: function logOut(reason) {
    this.logOutReason = reason;
    if (Auth.offline()) openPage("login");else Auth.logout();
  },

  clickUpdate: function clickUpdate() {
    if (inBrowser) {
      this.updateInBrowser();
    } else {
      var downloadUrl = mymobileConfig.mymobileUrl + "download.html?upgrade=yes" + "&model=" + encodeURIComponent(device.model) + "&os=" + encodeURIComponent(device.platform);
      window.open(downloadUrl, '_system');
    }
  },

  updateInBrowser: function updateInBrowser() {
    $("#app-update-progress").text($t("progress.updating_app"));
    $("#upgradeButton").hide();

    getApplicationVersion().done(function () {
      gLeaveOK = true;
      location.reload();
    }).fail(function () {
      $("#app-update-progress").text($t("errors.update_failure"));
    });
  }

};

var UsersPage = {

  init: function init() {
    checkNetworkConnection();
    this.fillTable();
  },

  loginUser: function loginUser(id) {
    Store.findSettings(id).then(function (settings) {
      if (settings && settings.length > 0) Auth.initOffline(settings[0].json.patientId, settings[0].json.patientName, settings[0].json.monitorProfileId, {
        success: function success() {
          openPage('main');
        },
        error: function error() {
          openPage('login');LoginPage.message($t("errors.no_offline"));
        }
      });
    });
  },

  fillTable: function fillTable() {
    var str = "";
    Store.getAllSettings().then(function (settings) {
      for (var i = 0; i < settings.length; i++) {
        if (settings[i].json.patientId) {
          str += ich.t_userMenuItem(settings[i].json, true);
        }
      }

      $('#users-menu').html($(str)).listview("refresh");
    });
  }
};

var RegisterPage = {

  regKey: null,
  resetPassword: false,

  setup: function setup() {
    $('#registerForm').on('submit', function (e) {
      e.preventDefault();RegisterPage.register();return false;
    });
    $('#registerButton').bind('click', function (e) {
      e.preventDefault();RegisterPage.register();return false;
    });
    $('#changePasswordButton').bind('click', function () {
      RegisterPage.register();
    });
    $('#cancelRegisterButton').bind('click', function () {
      RegisterPage.cancel();
    });
  },

  init: function init() {
    IdleHandler.stop();

    if (RegisterPage.regKey) {
      $('.registerPinSection').hide();
    } else {
      $('.registerPinSection').show();

      if (mymobileConfig.pin_only_registration) {
        $('.registerIdSection').hide();
      } else {
        $('.registerPinOnlySection').hide();
      }
    }

    if (RegisterPage.resetPassword) {
      $(".register-change").show();
      $(".register-new").hide();
    } else {
      $(".register-change").hide();
      $(".register-new").show();
    }

    RegisterPage.message(null);
  },

  message: function message(text) {
    if (text == "" || text == null) $('#register-message-div').hide();else {
      if (typeof text != "string") {
        text = text.join("<br/>");
      }
      $('#register-message-div').html(text).show();
    }
  },

  cancel: function cancel() {
    RegisterPage.regKey = null;
    RegisterPage.resetPassword = false;
    openPage('login');
  },

  register: function register() {
    var parameters = {
      username: $.trim($('#newUsernameInputField').val()),
      password: $.trim($('#newPasswordInputField').val()),
      password_confirmation: $.trim($('#newPasswordVerifyField').val()),
      deviceid: RegisterPage.regKey == null ? $.trim($('#deviceIdInputField').val()) : RegisterPage.regKey,
      hcn: $.trim($('#hcnInputField').val()),
      version: mymobileAppVersion.appVersion,
      browser: inBrowser
    };

    var errs = null;

    if (parameters.username == "" || parameters.password == "" || parameters.password_confirmation == "") errs = $t("errors.fill_in_all");

    if (RegisterPage.regKey == null && parameters.deviceid == "") errs = $t("errors.fill_in_all");

    if (RegisterPage.regKey == null && !mymobileConfig.pin_only_registration && parameters.hcn == "") errs = $t("errors.fill_in_all");

    if (errs == null && parameters.password != parameters.password_confirmation) errs = $t("errors.verify_password_unmatched");

    RegisterPage.message(null);

    if (errs != null) {
      RegisterPage.message(errs);
    } else {

      RegisterPage.message($t("progress.verifying"));

      postRegisterAsync(parameters).then(function (res) {

        Auth.initSession(res.invocationResult['hub-info']);

        RegisterPage.message($t("progress.logged_in"));
        $('.password-field').val('');

        finishLogin(false).then(function (res) {
          if (mymobileConfig.consent.patient_consent_required && !Profile.consent_granted) {
            openPage("consent");
          } else openPage("main");
        }, function (err) {
          RegisterPage.message($t("errors.no_login"));
        });
      }, function (err) {
        var online = checkNetworkConnection();
        var errs = $t(online ? "errors.no_server" : "errors.no_connection");
        try {
          errs = err.responseJSON.invocationResult.errors.error;
        } catch (exp) {}
        if (errs == "HubNotFound") {
          errs = $t("errors.hub_not_found");
        } else if (errs == 'PatientIsNotActive') {
          errs = $t("errors.pat_not_active");
        }

        RegisterPage.message(errs);
      });
    }
  }

};

var SettingsPage = {

  init: function init() {

    if (mymobileConfig.enable_privacy_policy && mymobileConfig.enable_terms_of_use) {
      $(".terms-and-privacy-header").show();
    } else {
      $(".terms-and-privacy-header").hide();
    }

    if (mymobileConfig.enable_privacy_policy) {
      $(".privacy-menu-item").show();
    } else {
      $(".privacy-menu-item").hide();
    }

    if (mymobileConfig.enable_terms_of_use) {
      $(".terms-menu-item").show();
    } else {
      $(".terms-menu-item").hide();
    }

    $("#history-table").show();
    var tbody = $("#history-table tbody");
    tbody.html($('<tr><td colspan="5">' + $t('progress.loading') + '</td></tr>'));
    Store.getAll().then(function (savedInterviews) {
      SettingsPage.fillTable(savedInterviews);
    }).fail(function (errorObject) {
      tbody.html($('<tr><td colspan="5">' + errorObject.msg + '</td></tr>'));
    });
  },

  fillTable: function fillTable(savedInterviews) {
    var tbody = $("#history-table tbody");
    if (savedInterviews.length == 0) {
      $("#history-table").hide();
    }
    tbody.empty();
    for (var i = 0; i < savedInterviews.length; i++) {
      var interviewData = savedInterviews[i];
      var row = $('<tr>');
      var startDate = new Date(Date.parse(interviewData.json.timeStarted));
      row.append($('<td>').text(interviewData.json.title));
      row.append($('<td>').text($l(startDate)));
      row.append($('<td>').text($t("messages.sync_status." + interviewData.json.syncStatus)));
      tbody.append(row);
    }
  }

};

function checkForAppUpdates() {
  if (inBrowser) {
    checkForBrowserAppUpdates();
  } else if (deviceOS == "Android" && !fromAppStore) {
    checkForAndroidAppUpdates();
  }
};

function checkForBrowserAppUpdates() {
  getApplicationVersion().done(function (result) {
    if (mymobileAppVersion.version != result.version) {
      $("#app-update-progress").text($t("menus.app_update_ready"));
      $("#app-update-ready").show();
      $("#upgradeButton").show();
    } else {
      $("#app-update-progress").text($t("progress.up_to_date"));
      $("#app-update-ready").hide();
      $("#upgradeButton").hide();
    }
  }).fail(function (result) {
    $("#app-update-progress").text($t("progress.up_to_date"));
    $("#app-update-ready").hide();
    $("#upgradeButton").show();
  });
}

function checkForAndroidAppUpdates() {
  getApplicationVersion().done(function (result) {
    var outOfDate = false;
    console.log("checking android version: server:" + result.apkversion + " local: " + mymobileAppVersion.apkversion);

    try {
      serverVersion = parseInt(result.apkversion);
      localVersion = parseInt(mymobileAppVersion.apkversion);
      outOfDate = localVersion < serverVersion;
    } catch (e) {
      console.log("bad apkversion:" + serverVersion);
    }

    if (outOfDate) {
      $("#app-update-progress").text($t("menus.app_update_ready"));
      $("#app-update-ready").show();
      $("#upgradeButton").show();
    } else {
      $("#app-update-progress").text($t("progress.up_to_date"));
      $("#app-update-ready").hide();
      $("#upgradeButton").hide();
    }
  }).fail(function (result) {
    $("#app-update-progress").text($t("progress.up_to_date"));
    $("#app-update-ready").hide();
    $("#upgradeButton").hide();
  });
}

var ConsentPage = {

  init: function init() {
    $('#consent-message').text("");
    this.updateDisplay();
  },

  goBack: function goBack() {
    if (Profile.consent_granted) {
      openPage('main');
    } else {
      Auth.logout();
      openPage("login");
    }
  },

  message: function message(_message) {
    $('#consent-message').text(_message);
  },

  updateDisplay: function updateDisplay() {
    $('#revoke-consent-button').hide();
    $('#decline-consent-button').hide();
    $('#consent-button').hide();

    if (!Profile.consent_granted) {
      $('#consent-button').show();
      $('#decline-consent-button').show();
    } else if (mymobileConfig.consent.allow_revoke_consent) {
      $('#revoke-consent-button').show();
    }
  },

  declineConsent: function declineConsent() {
    var _this3 = this;

    ConfirmDeclineConsentDialog.open(function () {
      _this3.sendNoConsent();
    });
  },

  giveConsent: function giveConsent() {
    var _this4 = this;

    postConsent(true).done(function (res) {
      Profile.consent_granted = true;
      openPage("main");
    }).fail(function (err) {
      _this4.updateDisplay();
      Profile.consent_granted = false;
      console.log(err);
      ConsentPage.message($t("errors.no_server"));
    });
  },

  sendNoConsent: function sendNoConsent() {
    var _this5 = this;

    postConsent(false).done(function (res) {
      Profile.consent_granted = false;
      MainPage.logOut('');
    }).fail(function (err) {
      _this5.updateDisplay();
      console.log(err);
      ConsentPage.message($t("errors.no_server"));
    });
  },

  revokeConsent: function revokeConsent() {
    var _this6 = this;

    ConfirmRevokeConsentDialog.open(function () {
      _this6.sendNoConsent();
    });
  }
};

var VideoPage = {

  init: function init() {

    VideoPage.vcauth = null;

    this.updateDisplay();

    this.checkToken();

    if (!Auth.offline()) {
      Auth.ping(); // will re update display if not signed in
    }
  },

  updateDisplay: function updateDisplay() {

    VideoPage.closePage();
    $('#video-start').hide();
    $('#video-join').hide();
    $('#video-message').hide();
    $('#video-wait').hide();

    if (Auth.offline()) {
      $('#video-message').show();
    } else {

      if (mymobileConfig.videoStartUrl != "") {
        if (!mymobileConfig.useExternalVideoConferencing || VideoPage.vcauth != null && VideoPage.vcauth.room != "") {

          if (VideoPage.vcauth != null && VideoPage.vcauth.caller != null) {
            var caller = $t("video.join").replace("{{caller_name}}", VideoPage.vcauth.caller);
            $('#video-start-text').text(caller);
          }

          $('#video-start').show();
        } else {
          $('#video-wait').show();
        }

        VideoPage.displayAppointments(false);
      }

      if (mymobileConfig.videoJoinUrl != "" && !mymobileConfig.useExternalVideoConferencing) {
        $('#video-join').show();
      }
    }
  },

  closePage: function closePage() {
    VideoPage.clearAppointments();
    stopLoadingSpinner();
    EmbeddedBrowser.stop();
  },

  startConference: function startConference() {
    var appt = Appointment.nextApptForPatient(parseInt(Auth.patientId()));
    if (appt && appt.isScheduled()) {
      appt.markComplete();
    }

    VideoPage.openLink(mymobileConfig.videoStartUrl);
  },

  declineConference: function declineConference() {

    VideoPage.clearToken();
  },

  joinConference: function joinConference() {
    VideoPage.openLink(mymobileConfig.videoJoinUrl);
  },

  checkToken: function checkToken() {
    VideoPage.vcauth = null;

    if (mymobileConfig.useExternalVideoConferencing) {
      Auth.vcToken().then(function (res) {
        if (res["invocationResult"] && res["invocationResult"].vcauth) {
          VideoPage.vcauth = res["invocationResult"].vcauth;
          VideoPage.updateDisplay();
        }
      });
    }
  },

  clearToken: function clearToken() {
    VideoPage.vcauth = null;
    VideoPage.updateDisplay();

    if (mymobileConfig.useExternalVideoConferencing) {
      Auth.vcTokenClear();
    }
  },

  openLink: function openLink(url) {
    VideoPage.windowReference = window.open("", "vcmm_window");

    if (mymobileConfig.useExternalVideoConferencing) {
      Auth.vcToken().then(function (res) {
        if (res["invocationResult"] == null || res["invocationResult"].vcauth == null) {
          VideoPage.vcauth = null;
        } else {
          VideoPage.vcauth = res["invocationResult"].vcauth;
        }

        VideoPage.openExternalVCLink(url, VideoPage.vcauth);
        VideoPage.updateDisplay();
      });
    } else {
      VideoPage.openMyvideoLink(url);
    }
  },

  openExternalVCLink: function openExternalVCLink(url, vcauth) {

    if (mymobileConfig.videoConferencingProvider == "tokbox") {

      var config = {
        token: vcauth.token,
        resourceId: vcauth.room,
        displayName: Auth.patientName()
      };

      localStorage.setItem("VC", JSON.stringify(config));
    } else {
      url = url.replace("{{token}}", encodeURIComponent(vcauth.token));
      url = url.replace("{{resourceId}}", encodeURIComponent(vcauth.room));
      url = url.replace("{{displayName}}", encodeURIComponent(Auth.patientName()));
      url = url.replace("{{host}}", encodeURIComponent(mymobileConfig.vidyoHost));
    }

    gLeaveOK = true;
    VideoPage.windowReference.location = url;
    setTimeout(function () {
      gLeaveOK = false;
    }, 1000);
  },

  openMyvideoLink: function openMyvideoLink(url) {

    url = url.replace("{{patientid}}", Auth.patientId());

    var date = new Date();
    var dt = moment(date).utc().format("YYYY-MM-DD HH:mm:ss");
    var id = Auth.patientId() + "|" + Auth.profileId() + "|" + dt;
    var shaid = pidCrypt.SHA256(id);

    url = url.replace("{{sha256}}", shaid);

    if (inBrowser || deviceOS == "iOS" || !mymobileConfig.embedVideoConferencing) {
      gLeaveOK = true;
      VideoPage.windowReference.location = url;
      setTimeout(function () {
        gLeaveOK = false;
      }, 1000);
    } else {

      var callbacks = {
        loadStart: function loadStart() {
          console.log('- loadStart');
          startLoadingSpinner();
        },
        loadStop: function loadStop() {
          console.log('- loadStop');
          stopLoadingSpinner();
        },
        loadError: function loadError(err) {
          console.log('- loadError');
          stopLoadingSpinner();

          if (err == "ALREADY ACTIVE") {
            console.log("ALREADY ACTIVE");
          } else {
            var scriptErrorMesssage = $t("errors.vc_unavailable");
            if (!checkNetworkConnection()) {
              scriptErrorMesssage = $t("errors.no_vc_connection");
            }

            simpleAlert($t("errors.vc_alert_title"), scriptErrorMesssage, $("#video-menu")[0]);
          }
        }
      };

      console.log("check camera permission");
      var permissions = cordova.plugins.permissions;

      permissions.requestPermission(permissions.CAMERA, function (status) {
        console.log(status);
        var browser = new EmbeddedBrowser();
        browser.show(url, callbacks);
      }, function () {
        console.warn('Camera permission is not turned on');
      });
    }
  },

  startAppointment: function startAppointment(id, active) {
    if (active) {
      VideoPage.startConference();
      VideoPage.displayAppointments(false);
    } else {
      openMessagePopup($t("video.video_conference_is_pending"), "#video-conf-menu-" + id);
    }
  },

  clearAppointments: function clearAppointments() {
    $('#video-menu li.appointment').remove();
  },

  refresh: function refresh() {

    VideoPage.clearAppointments();

    getAppointments().then(function (appointments) {
      VideoPage.displayAppointments(!mymobileConfig.useExternalVideoConferencing);
    }, function (err) {
      openMessagePopup($t("video.not_available_offline"), null);
    });

    this.checkToken();
  },

  displayAppointments: function displayAppointments(showMessage) {

    VideoPage.clearAppointments();
    var apptListMarkup = [];
    var appts = Appointment.allApptsForPatient(parseInt(Auth.patientId()));
    if (showMessage && appts.length == 0) {
      openMessagePopup($t("video.no_scheduled_appointments"), null);
    }

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = appts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var appt = _step.value;


        var dispItem = new AppointmentDisplayItem(appt, false);
        dispItem.iconName = "clock";
        if (dispItem.active) {
          dispItem.startText = $t("buttons.start");
          dispItem.iconName = "ready";
        }

        var apptHTML = ich.t_appointmentMenuItem(dispItem);
        apptListMarkup.push(apptHTML[0]);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    $('#video-menu').append($(apptListMarkup));
  }
};

function openPage(name, delay) {
  if (!name) {
    return;
  }

  if (delay == 'nodelay ') {
    checkNetworkConnection();
    changePage(name);
  } else {
    checkNetworkConnection();
    setTimeout(function () {
      changePage(name);
    }, RIPPLE_OPTIONS.buttonWait); // let ripple finish
  }
}
function changePage(name) {
  checkNetworkConnection();
  $(":mobile-pagecontainer").pagecontainer("change", "#" + name.replace("#", ""), { changeHash: false });
}

function submitPendingMessages() {
  var messages = Store.getMessages().then(function (messages) {
    if (messages.length <= 0) {
      console.log("No pending messages to send.");
      return;
    }
    console.log("Sending " + messages.length + " pending messages");
    doPostMessages(messages.map(function (message) {
      return message.json.message_json;
    }));
  });
}

function submitPendingInterviews() {
  Store.getAll().then(function (interviews) {
    if (interviews.length == 0) {
      setMainSyncStatus();
    }

    for (var i = 0; i < interviews.length; i++) {
      var interviewData = interviews[i];
      if (interviewData.json.syncStatus != 'syncing') {
        interviewData.json.syncStatus = 'syncing';
        SettingsPage.fillTable(interviews);
        doPostInterview(interviewData, interviews);
      }
    }
  });
}

function clearSyncingInterviews() {
  Store.getAll().then(function (interviews) {
    for (var i = 0; i < interviews.length; i++) {
      var interviewData = interviews[i];
      if (interviewData.json.syncStatus == 'syncing') {
        interviewData.json.syncStatus = 'pending';
      }
    }
  });
}

function doPostInterview(interviewData, interviews) {
  $('#sync_status').text($t("messages.sync_status.syncing"));

  postInterviews(interviewData.json.xml, {
    onSuccess: function onSuccess(result) {
      Store.remove(interviewData);
      interviewData.json.syncStatus = 'synced';
      SettingsPage.fillTable(interviews);
      Store.getAll().then(function (interviews) {
        if (interviews.length == 0) {
          Store.setLastSyncDate();
        }
        setMainSyncStatus();
      });
    },
    onFailure: function onFailure(result) {

      if (result.status == 401) {
        Auth.goOffline();
      }

      interviewData.json.syncStatus = 'failed';
      var errs = $t("errors.sync_failure");
      try {
        errs = result.responseJSON.invocationResult.errors.error;
      } catch (exp) {}
      interviewData.json.error = errs;
      SettingsPage.fillTable(interviews);
      setMainSyncStatus();
      $('.sync_summary').text(errs);
    }
  });
}

function doPostMessages(messages) {
  var msgJSON = JSON.stringify(messages);
  postMessages(msgJSON, {
    onSuccess: function onSuccess(result) {
      console.log(result);
      console.log("Messages Posted.");
      Store.clearMessages();
    },
    onFailure: function onFailure(result) {
      console.log(result);
      console.log("Error posting messages");
    }
  });
}

function submitHealthkitData() {
  if (inBrowser || deviceOS != "iOS" || !mymobileConfig.healthKitEnabled) {
    console.error("Healthkit not available on non iOS devices or is not enabled.");
    return;
  }

  if (!Profile.healthKitEnabled()) {
    console.error("Healthkit not enabled in Monitor Profile.");
    return;
  }

  Healthkit.checkAvailability().then(Healthkit.getAll).then(function (result) {
    console.log("Got Healthkit data: ");
    console.log(result);

    var healthkitData = Healthkit.parseData(result);

    if (!healthkitData) {
      console.log("No new Healthkit Data. Cancel sending.");
      return;
    }

    var readingsJSON = healthkitData;
    postReadings(readingsJSON, {
      onSuccess: function onSuccess(result) {
        console.log("HealthKit Readings sent.");
      },
      onFailure: function onFailure(error) {
        console.error("Error sending Healthkit readings.");
        console.error(error);
      }
    });
  });
}

function doPostGetGraphData(measurementId, name, sensorTypeId, dateRange) {

  var patientId = Auth.patientId();

  console.log("doPostGetGraphData:: Patient: " + patientId + " Measurement: " + measurementId + " name: " + name + " sensorTypeId: " + sensorTypeId + " dateRange: " + dateRange);

  postGetGraphData({ "patient_id": patientId, "name": name, "measurement_id": measurementId, "date_range": dateRange }, {
    onSuccess: function onSuccess(result) {
      var graphData = result.invocationResult;

      if (typeof result.invocationResult == 'string') {
        graphData = $.parseJSON(result.invocationResult);
      }

      Store.saveGraphData({ "patient_id": patientId, "measurement_id": measurementId, "date_range": dateRange, "data": graphData });
      reloadGraphs();
    },
    onFailure: function onFailure(result) {
      if (result.status == 401) {
        //  most likely timed out - refresh whole page
        VitalsPage.reset();
        VitalsPage.init();
        Auth.goOffline();
      }
      console.error("Error getting graph data:", result);
    }
  });
}

function reloadGraphs() {
  var graph_divs = $(".vital-graph");
  graph_divs.each(function (index, elem) {
    if ($(elem).is(":visible")) {
      setTimeout(function () {
        loadGraph(elem);
      }, 200 * (index + 1));
    }
  });
}

function loadGraph(elem, range) {

  var dateRange = typeof range !== 'undefined' ? range : $(elem).attr('data-date-range');

  var graphIndex = parseInt($(elem).data("graphIndex"));
  var measurementId = $(elem).data('measurement-id'); //Sometimes this is comma separated integers
  var measurementName = $(elem).data('measurement-name');
  var sensorTypeId = $(elem).data('sensor-type-id');

  var data = null;
  var options = null;

  Store.loadGraphData(measurementId, dateRange).then(function (graphData) {

    if (graphData.length <= 0) {
      doPostGetGraphData(measurementId, measurementName, sensorTypeId, dateRange);
      return;
    }

    graphData = graphData[0];
    $(elem).find('div.vital-graph-loading').hide();

    var prepared_data = GraphSupport.prepareGraphData(graphData.json.data, measurementName);

    var options = GraphSupport.prepareGraphOptions(prepared_data, dateRange);

    var plot = $.plot(elem, prepared_data, options);
    drawLabels(elem, plot, graphData.json.data);
  });
}

var previousPoint = [];

function drawLabels(plotElem, plot, data) {
  $(plotElem).bind("plotclick", function (event, pos, item) {
    GraphSupport.graphHover(event, pos, item, data.units, data.decimal_places, data.value_names);
  });
}

function lookupRagStatus(value) {
  if (value == 3) {
    return $t("colors.red");
  } else if (value == 2) {
    return $t("colors.amber");
  } else {
    return $t("colors.green");
  }
}

var gSettings = {};
var gTheme = { letter: 'h' };
var gContentLookup = {
  terms_of_use: "content.terms_of_use",
  privacy_policy: "content.privacy",
  contact_carer: "content.contact_content",
  consent_agreement: "content.consent_agreement",
  about_mymobile: "content.about"
};

function loadPrivacyPolicyFromStore() {
  Store.getPrivacyPolicy().done(function (data) {
    if (data && data.length > 0) {
      var pp = data[0].json["privacy-policy"];
      if (pp) {
        $('#privacy_policy_from_tm').html(pp.text);
      }

      var sc = data[0].json["static-contents"];
      if (sc) {

        var scList = asList(sc["static-content"]);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = scList[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var sContent = _step2.value;


            var trList = asList(sContent.translations.translation);
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = trList[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var sTrans = _step3.value;


                // add to standard translation manager
                var bundle = { static_content: {} };
                bundle.static_content[sContent['content-type']] = sTrans.text;
                i18n.addResourceBundle(sTrans.locale, "translation", bundle);
              }

              // look up text in standard translation manager
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            var text = $t("static_content." + sContent['content-type']);
            if (!text || text == "") {
              // default to local settings if missing
              text = $t(gContentLookup[sContent['content-type']]);
            }

            text = text.replace("{server_url}", '<span class="activated-url"></span>');
            $("#" + sContent['content-type'] + "_from_tm").html(text);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  });
}

function loadInterviewsFromStore(callback) {
  Store.loadInterviews().then(function (interviews) {
    if (interviews != null && interviews.length > 0) {
      Interviews.init(interviews[0].json);
      Store.loadCurrentProfile().then(function (profiles) {
        if (profiles != null && profiles.length > 0) {
          Profile.init(profiles[0].json);
          callback.success();
        } else {
          callback.error();
        }
      }).fail(function () {
        callback.error();
      });
    } else {
      callback.error();
    }
  }).fail(function () {
    callback.error();
  });
}

function loadGraphDataFromStore(measurementId, callback) {
  Store.loadGraphData(measurementId).then(function (graphData) {
    Interviews.init(interviews[0].json);
  });
}

function saveSettings() {
  return Store.saveSettings(gSettings);
}

function defaultSettings() {
  return {
    patientId: Auth.patientId(),
    patientName: Auth.patientName(),
    lastSyncDate: null,
    rememberMe: false,
    theme: 'h'
  };
}

function loadSettings() {
  Store.getSettings().then(function (settings) {
    if (settings == null || settings.length == 0) {
      Store.saveSettings(defaultSettings()).then(function (newSettings) {
        gSettings = newSettings;updateTheme();
      });
    } else {
      gSettings = settings[0];
      gSettings.json.patientName = Auth.patientName();
      saveSettings();
      updateTheme();
    }
  });
}

function updateTheme() {
  /*
    if( gSettings && gSettings.json && gSettings.json.theme ) {
      gTheme.letter = gSettings.json.theme.replace('data-theme-','');
      changeGlobalTheme( gTheme.letter );
    }
    */
}

function setThemeClass(baseClass, theme) {
  var themes = ['f', 'g', 'h', 'i'];
  var cssSelector = $.map(themes, function (letter, i) {
    return "." + baseClass + "-" + letter;
  }).join(", ");
  var oldClasses = $.map(themes, function (letter, i) {
    return baseClass + "-" + letter;
  }).join(" ");
  $(cssSelector).removeClass(oldClasses).addClass(baseClass + "-" + theme);
}

function changeGlobalTheme(theme) {
  setThemeClass("ui-overlay", theme);
  setThemeClass("ui-page-theme", theme);
  setThemeClass("ui-page-theme", theme);

  $("body>div[data-role=page]").attr('data-theme', theme);
};

function setMainSyncStatus() {
  Promise.all([Store.getAll(), Store.getMessages()]).then(function (responses) {

    var savedInterviews = responses[0];
    var savedMessages = responses[1];

    var interviewsPending = 0;
    var interviewsSyncing = 0;
    for (var index in savedInterviews) {
      var interviewData = savedInterviews[index];
      if (interviewData.json.syncStatus == "pending" || interviewData.json.syncStatus == "failed") {
        interviewsPending += 1;
      } else if (interviewData.json.syncStatus == "syncing") {
        interviewsSyncing += 1;
      }
    }

    var messagesPending = savedMessages.length;

    var status = "";
    var syncDate = Store.getLastSyncDate();

    $("#main-sync>a>img").remove();
    $("#main-sync>a").prepend($('<img src="css/images/icons-color/synchronize.svg" class="ui-li-icon sync-icon   large-li-icon">'));

    // Show that we are syncing 
    if (!Auth.offline() && (interviewsSyncing > 0 || MainPage.loadingInterviews)) {
      status = $t(interviewsSyncing > 0 ? "messages.sync_status.syncing" : "progress.loading_interviews");
      $(".sync-icon").addClass("spinning").css("animation-play-state", "running");
      $('.sync_summary').html(status);
      return;
    }

    //Show that we have data waiting to be sent
    if (interviewsPending > 0 || messagesPending > 0) {

      if (Auth.offline()) {
        status = $t("messages.log_in_to_sync_pending") + ". ";
      } else {
        status = $t("messages.sync_status.pending_sync") + ". ";
      }
      if (interviewsPending > 0) {
        status = status + $t("messages.sync_status.interviews_pending") + ": " + interviewsPending + " ";
      }
      if (messagesPending > 0) {
        status = status + $t("messages.sync_status.messages_pending") + ": " + messagesPending;
      }
      $('.sync_summary').html(status);
      return;
    }

    //Show that all data is sent, and the date we last synced. Should not get here if there is pending data.
    if (syncDate != null) {
      status = $t("messages.sync_status.last_sync") + ": " + prettyDate(new Date(syncDate));
      if (Auth.offline()) {
        status = $t("messages.log_in_to_sync") + "\n<br/>" + status;
      }
    } else {
      if (Auth.offline()) {
        status = $t("messages.log_in_to_sync");
      } else {
        status = $t("messages.sync_status.up_to_date");
      }
    }
    $('.sync_summary').html(status);
  }).catch(function (errorObject) {
    $('.sync_summary').text(errorObject.msg);
  });
}

function addNotification(id, title, text, at, every) {
  //https://github.com/katzer/cordova-plugin-local-notifications
  console.log("Adding Notification: ", "id: " + id, "title: " + title, "text: " + text, "at: " + at, "Every: " + every);

  if (!at) {
    console.error("Cannot create notification. No Date specified.");
    return;
  }

  window.plugin.notification.local.schedule({
    id: id,
    title: title,
    text: text,
    at: at,
    every: every
  });
}

function clearNotifications(success) {
  console.log("Clearing Notifications");
  window.plugin.notification.local.cancelAll(function () {
    console.log("All alarms cancelled.");
    success();
  });
}

function refreshNotifications() {
  //Don't set notifications in web app.
  if (inBrowser) {
    return;
  }

  clearNotifications(function () {
    createNotifications();
  });
}

function createNotifications() {
  if (inBrowser) {
    return;
  }

  var times_ahead = mymobileConfig.notificationLookAhead;
  console.log("Creating notifications " + times_ahead + " times in the future.");

  var patientList = Store.getPatientList();
  var patientInfoList = [];
  var patInfo, i;
  for (i = 0; i < patientList.length; i++) {
    patInfo = patientList[i].json;
    Store.loadPatientProfile(patInfo.patientId).then(function (profiles) {
      if (profiles != null && profiles.length > 0) {
        var scheds = Profile.readSchedules(profiles[0].json, false);
        patientInfoList.push({ name: patInfo.patientName, scheds: scheds });
      }
    });
  }

  for (var patIndex = 0; patIndex < patientInfoList.length; patIndex++) {
    patInfo = patientInfoList[patIndex];
    var patientName = patientList.length > 1 ? "  " + patInfo.name : "";
    var notificationID;
    for (i = 0; i < patInfo.scheds.length; i++) {
      if (!notificationID) {
        notificationID = parseInt(1000000 * (patIndex + 1) + 1000 * (i + 1));
      }

      var schedInfo = patInfo.scheds[i];

      //Check if we are past the end Date
      if (schedInfo.end_date && moment(schedInfo.end_date) < moment()) {
        continue;
      }

      //Daily repeating events
      if (schedInfo.time && schedInfo.time.days && schedInfo.time.days.length == 7) {
        var startTime = schedInfo.getFollowingTimes(new Date(), 1)[0];
        addNotification(notificationID, schedInfo.interviewName, schedInfo.scheduleTime() + patientName, startTime, 'day');
        notificationID++;
        continue;
      }

      //Specific day weekly repeating schedules
      if (schedInfo.time && schedInfo.time.days && schedInfo.time.days.length < 7 && schedInfo.time.days.length > 0 && schedInfo.every_no_times && schedInfo.every_no_times == "1") {
        var startTimes = schedInfo.getFollowingTimes(new Date(), schedInfo.time.days.length);

        for (var index in startTimes) {
          addNotification(notificationID, schedInfo.interviewName, schedInfo.scheduleTime() + patientName, startTimes[index], 'week');
          notificationID++;
        }
        continue;
      }

      //Monthly repeating
      if (schedInfo.day_of_month && schedInfo.every_no_times && schedInfo.every_no_times == "1") {
        var startTime = schedInfo.getFollowingTimes(new Date(), 1)[0];
        addNotification(notificationID, schedInfo.interviewName, schedInfo.scheduleTime() + patientName, startTime, 'month');
        notificationID++;
        continue;
      }

      //Non daily events
      var upcomingStartTimes = schedInfo.getFollowingTimes(new Date(), times_ahead);

      for (var j = 0; j < upcomingStartTimes.length; j++) {
        var id = parseInt(1000000 * (patIndex + 1) + 1000 * (i + 1) + j + 1);
        addNotification(notificationID, schedInfo.interviewName, schedInfo.scheduleTime() + patientName, upcomingStartTimes[j]);
        notificationID++;
      }
    }
  }
}

function openMessagePopup(text, over) {
  $("#messagePopup p").text(text);
  $("#messagePopup").popup('open', { history: false, positionTo: over });
}

function openWarningPopup(text) {
  $("#warningPopup p").text(text);
  $("#warningPopup").popup('open', { history: false });
}

function closeWarningPopup(text) {
  $("#warningPopup").popup('close');
}

function checkNetworkConnection() {
  var connected;

  if (inBrowser) {
    connected = navigator.onLine;
  } else {
    connected = navigator.connection.type != Connection.NONE;
  }
  if (connected === false) {
    setTimeout(function () {
      openWarningPopup($t("errors.connection_lost"));
    }, RIPPLE_OPTIONS.buttonWait);
  }

  return connected;
}

function localFilePath(path) {
  if (inBrowser) {
    return path;
  } else {
    return cordova.file.applicationDirectory + 'www' + path;
  }
}

var Speak = function () {
  function Speak() {
    _classCallCheck(this, Speak);
  }

  _createClass(Speak, null, [{
    key: "continueIfChanged",
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(text) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(text.replace(/\./g, "") != Speak.lastString.replace(/\./g, ""))) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", Speak.speakString(text, delay));

              case 2:
                return _context4.abrupt("return", false);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function continueIfChanged(_x3) {
        return _ref4.apply(this, arguments);
      }

      return continueIfChanged;
    }()
  }, {
    key: "continue",
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(text) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", Speak.speakString(text, delay));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _continue(_x5) {
        return _ref5.apply(this, arguments);
      }

      return _continue;
    }()
  }, {
    key: "interrupt",
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(text) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                Speak.stop();
                return _context6.abrupt("return", Speak.speakString(text, delay));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function interrupt(_x7) {
        return _ref6.apply(this, arguments);
      }

      return interrupt;
    }()
  }, {
    key: "stop",
    value: function stop() {
      if (inBrowser) {
        if (window.speechSynthesis) {
          speechSynthesis.cancel();
        }
      } else {
        TTS.stop();
      }
    }
  }, {
    key: "setVolume",
    value: function setVolume(newVol) {
      Store.setVolume(newVol);
      if (newVol == "off") {
        Speak.stop();
      }
    }
  }, {
    key: "subUnits",
    value: function subUnits(str) {
      if (Speak.unitSubstitutions == null) {
        Speak.unitSubstitutions = $t("speech_substitutions", { returnObjectTrees: true });
      }

      if (_typeof(Speak.unitSubstitutions) == "object") {
        for (var key in Speak.unitSubstitutions) {
          str = str.replace(key, Speak.unitSubstitutions[key]);
        }
      }

      return str;
    }
  }, {
    key: "subVitals",
    value: function subVitals(str) {
      if (Speak.vitalSubstitutions == null) {
        Speak.vitalSubstitutions = $t("vital_speech_substitutions", { returnObjectTrees: true });
      }

      if (_typeof(Speak.vitalSubstitutions) == "object") {
        for (var key in Speak.vitalSubstitutions) {
          str = str.replace(key, Speak.vitalSubstitutions[key]);
        }
      }

      return str;
    }
  }, {
    key: "subGeneral",
    value: function subGeneral(str) {
      if (Speak.generalSubstitutions == null) {
        Speak.generalSubstitutions = $t("general_speech_substitutions", { returnObjectTrees: true });
      }

      if (_typeof(Speak.generalSubstitutions) == "object") {
        for (var key in Speak.generalSubstitutions) {
          key = key.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
          var regEx = new RegExp("\\b(" + key + ")\\b", 'g');
          str = str.replace(key, Speak.generalSubstitutions[key]);
        }
      }

      return str;
    }
  }, {
    key: "speakString",
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(str) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(Store.getVolume() == "off")) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", true);

              case 2:

                str = this.subGeneral(str);

                if (!inBrowser) {
                  _context7.next = 7;
                  break;
                }

                return _context7.abrupt("return", this.speakStringBrowser(str, delay));

              case 7:
                return _context7.abrupt("return", this.speakStringNative(str, delay));

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function speakString(_x9) {
        return _ref7.apply(this, arguments);
      }

      return speakString;
    }()
  }, {
    key: "speakStringNative",
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(str) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var ttsOpts;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                ttsOpts = {
                  text: str,
                  locale: LocaleManager.locale,
                  rate: 1.0,
                  preDelay: delay
                };


                Speak.lastString = str;
                console.log("Speaking: " + str);
                return _context8.abrupt("return", new Promise(function (resolve, reject) {
                  TTS.speak(ttsOpts, function () {
                    console.log("Speak Success: " + str);
                    resolve(true);
                  }, function (reason) {
                    console.error("Speak failed: " + str + " " + reason);
                    reject(reason);
                  });
                }));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function speakStringNative(_x11) {
        return _ref8.apply(this, arguments);
      }

      return speakStringNative;
    }()
  }, {
    key: "speakStringBrowser",
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(str) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (window.speechSynthesis) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt("return", false);

              case 2:
                return _context9.abrupt("return", new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    var utterThis = new SpeechSynthesisUtterance(str);
                    utterThis.rate = 1.0;

                    speechSynthesis.speak(utterThis);
                    resolve(true);
                  }, delay);
                }));

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function speakStringBrowser(_x13) {
        return _ref9.apply(this, arguments);
      }

      return speakStringBrowser;
    }()
  }]);

  return Speak;
}();

Speak.lastString = "";
Speak.unitSubstitutions = null;
Speak.vitalSubstitutions = null;
Speak.generalSubstitutions = null;

var ConfirmSignOutDialog = function () {
  function ConfirmSignOutDialog() {
    _classCallCheck(this, ConfirmSignOutDialog);
  }

  _createClass(ConfirmSignOutDialog, null, [{
    key: "open",
    value: function open() {
      $("#ConfirmSignOutDialog").show().popup('open', { history: false });
    }
  }, {
    key: "ok",
    value: function ok() {
      $("#ConfirmSignOutDialog").popup('close');
      MainPage.logOut('');
    }
  }, {
    key: "cancel",
    value: function cancel() {
      $("#ConfirmSignOutDialog").popup('close');
    }
  }]);

  return ConfirmSignOutDialog;
}();

var ConfirmRevokeConsentDialog = function () {
  function ConfirmRevokeConsentDialog() {
    _classCallCheck(this, ConfirmRevokeConsentDialog);
  }

  _createClass(ConfirmRevokeConsentDialog, null, [{
    key: "open",
    value: function open(callback) {
      this.callback = callback;
      $("#ConfirmRevokeConsentDialog").show().popup('open', { history: false });
    }
  }, {
    key: "ok",
    value: function ok() {
      $("#ConfirmRevokeConsentDialog").popup('close');
      this.callback();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      $("#ConfirmRevokeConsentDialog").popup('close');
    }
  }]);

  return ConfirmRevokeConsentDialog;
}();

var ConfirmDeclineConsentDialog = function () {
  function ConfirmDeclineConsentDialog() {
    _classCallCheck(this, ConfirmDeclineConsentDialog);
  }

  _createClass(ConfirmDeclineConsentDialog, null, [{
    key: "open",
    value: function open(callback) {
      this.callback = callback;
      $("#ConfirmDeclineConsentDialog").show().popup('open', { history: false });
    }
  }, {
    key: "ok",
    value: function ok() {
      $("#ConfirmDeclineConsentDialog").popup('close');
      this.callback();
    }
  }, {
    key: "cancel",
    value: function cancel() {
      $("#ConfirmDeclineConsentDialog").popup('close');
    }
  }]);

  return ConfirmDeclineConsentDialog;
}();

var BrowserConfirmDialog = function () {
  function BrowserConfirmDialog() {
    _classCallCheck(this, BrowserConfirmDialog);
  }

  _createClass(BrowserConfirmDialog, null, [{
    key: "open",
    value: function open(callback) {
      BrowserConfirmDialog.callback = callback;

      $("#confirmPopup").show().popup('open', { history: false });
    }
  }, {
    key: "ok",
    value: function ok() {
      $("#confirmPopup").popup('close');
      ConfirmDialog.callback(true);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      $("#confirmPopup").popup('close');
      ConfirmDialog.callback(false);
    }
  }]);

  return BrowserConfirmDialog;
}();

BrowserConfirmDialog.callback = null;

var NativeConfirmDialog = function () {
  function NativeConfirmDialog() {
    _classCallCheck(this, NativeConfirmDialog);
  }

  _createClass(NativeConfirmDialog, null, [{
    key: "open",
    value: function open(callback) {

      navigator.notification.confirm($t("messages.confirm_remember_me"), function (result) {
        callback(result == 1);
      }, $t("messages.confirm_remember_me_title"), [$t('buttons.ok'), $t('buttons.cancel')]);
    }
  }]);

  return NativeConfirmDialog;
}();

var ConfirmDialog;

if (inBrowser) {
  ConfirmDialog = BrowserConfirmDialog;
} else {
  ConfirmDialog = NativeConfirmDialog;
}

var SecureStore = function () {
  function SecureStore() {
    _classCallCheck(this, SecureStore);
  }

  _createClass(SecureStore, [{
    key: "checkRememberMe",
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.getStore();

              case 3:
                _context10.next = 5;
                return this.getValue(SecureStore.key);

              case 5:
                return _context10.abrupt("return", _context10.sent);

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                return _context10.abrupt("return", null);

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));

      function checkRememberMe() {
        return _ref10.apply(this, arguments);
      }

      return checkRememberMe;
    }()
  }, {
    key: "clearAllRememberMe",
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                _context11.next = 3;
                return this.getStore();

              case 3:
                _context11.next = 5;
                return this.clear();

              case 5:
                Store.clearAllRememberMe();
                _context11.next = 11;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);

                console.error(_context11.t0);

              case 11:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 8]]);
      }));

      function clearAllRememberMe() {
        return _ref11.apply(this, arguments);
      }

      return clearAllRememberMe;
    }()
  }, {
    key: "setRememberMe",
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(val) {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                _context12.next = 3;
                return this.getStore();

              case 3:
                if (!(deviceOS == 'iOS')) {
                  _context12.next = 6;
                  break;
                }

                _context12.next = 6;
                return this.remove(SecureStore.key);

              case 6:
                _context12.next = 8;
                return this.setValue(SecureStore.key, val);

              case 8:
                Store.setRememberMe("Yes");
                _context12.next = 14;
                break;

              case 11:
                _context12.prev = 11;
                _context12.t0 = _context12["catch"](0);

                console.error(_context12.t0);

              case 14:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 11]]);
      }));

      function setRememberMe(_x14) {
        return _ref12.apply(this, arguments);
      }

      return setRememberMe;
    }()
  }, {
    key: "clear",
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var _this7 = this;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", new Promise(function (resolve, reject) {
                  _this7.ss.clear(function () {
                    resolve();
                  }, function (error) {
                    console.error("Could not clear secureStorage. Probably Empty.");
                    console.error(error);
                    resolve();
                  });
                }));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function clear() {
        return _ref13.apply(this, arguments);
      }

      return clear;
    }()
  }, {
    key: "getValue",
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(key) {
        var _this8 = this;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", new Promise(function (resolve, reject) {
                  _this8.ss.get(function (value) {
                    resolve(value);
                  }, function (error) {
                    reject(error);
                  }, key);
                }));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getValue(_x15) {
        return _ref14.apply(this, arguments);
      }

      return getValue;
    }()
  }, {
    key: "setValue",
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(key, val) {
        var _this9 = this;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", new Promise(function (resolve, reject) {
                  _this9.ss.set(function (key) {
                    resolve(key);
                  }, function (error) {
                    reject(error);
                  }, key, val);
                }));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setValue(_x16, _x17) {
        return _ref15.apply(this, arguments);
      }

      return setValue;
    }()
  }, {
    key: "remove",
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(key) {
        var _this10 = this;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", new Promise(function (resolve, reject) {
                  _this10.ss.remove(function (key) {
                    resolve(key);
                  }, function (error) {
                    console.error("Could not remove key from SecureStorage." + key);
                    resolve();
                  }, key);
                }));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function remove(_x18) {
        return _ref16.apply(this, arguments);
      }

      return remove;
    }()
  }, {
    key: "getStore",
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var _this11 = this;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.ss = null;
                return _context17.abrupt("return", new Promise(function (resolve, reject) {
                  _this11.ss = new cordova.plugins.SecureStorage(function () {
                    console.log("getStore ok: ");
                    resolve(true);
                  }, function (error) {
                    console.error("getStore failed: " + error);
                    reject(error);
                  }, SecureStore.serviceName);
                }));

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getStore() {
        return _ref17.apply(this, arguments);
      }

      return getStore;
    }()
  }, {
    key: "getStoreAndValidate",
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var self;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                self = this;
                _context18.prev = 1;
                _context18.next = 4;
                return this.getStore();

              case 4:
                _context18.next = 11;
                break;

              case 6:
                _context18.prev = 6;
                _context18.t0 = _context18["catch"](1);

                console.error(_context18.t0);
                console.error("getStore failed: ");

                return _context18.abrupt("return", new Promise(function (resolve, reject) {
                  navigator.notification.alert($t("messages.enable_screen_lock"), function () {
                    self.ss.secureDevice(function () {
                      resolve('OK');
                    }, function () {
                      reject('Not Secure');
                    });
                  }, $t("messages.enable_screen_lock_title"));
                }));

              case 11:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[1, 6]]);
      }));

      function getStoreAndValidate() {
        return _ref18.apply(this, arguments);
      }

      return getStoreAndValidate;
    }()
  }], [{
    key: "get",
    value: function get() {

      if (SecureStore.instance == null) {
        if (inBrowser || !mymobileConfig.rememberMeSecure) {
          SecureStore.instance = new BrowserStore();
        } else {
          SecureStore.instance = new SecureStore();
        }
      }

      return SecureStore.instance;
    }
  }]);

  return SecureStore;
}();

SecureStore.instance = null;
SecureStore.key = 'com.kanayo.mymobile';
SecureStore.serviceName = 'com.kanayo';

var BrowserStore = function () {
  function BrowserStore() {
    _classCallCheck(this, BrowserStore);
  }

  _createClass(BrowserStore, [{
    key: "checkRememberMe",
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", Store.checkRememberMe());

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function checkRememberMe() {
        return _ref19.apply(this, arguments);
      }

      return checkRememberMe;
    }()
  }, {
    key: "clearAllRememberMe",
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                Store.clearAllRememberMe();

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function clearAllRememberMe() {
        return _ref20.apply(this, arguments);
      }

      return clearAllRememberMe;
    }()
  }, {
    key: "setRememberMe",
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(val) {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                Store.setRememberMe(val);

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function setRememberMe(_x19) {
        return _ref21.apply(this, arguments);
      }

      return setRememberMe;
    }()
  }, {
    key: "getStoreAndValidate",
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", true);

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getStoreAndValidate() {
        return _ref22.apply(this, arguments);
      }

      return getStoreAndValidate;
    }()
  }]);

  return BrowserStore;
}();

var EmbeddedBrowser = function () {
  function EmbeddedBrowser() {
    _classCallCheck(this, EmbeddedBrowser);
  }

  _createClass(EmbeddedBrowser, [{
    key: "show",
    value: function show(url, callbacks) {
      var _this12 = this;

      if (EmbeddedBrowser.active !== null) {
        this.onLoadError("ALREADY ACTIVE");
        return;
      }

      IdleHandler.stop();

      EmbeddedBrowser.active = this;

      this.callbacks = callbacks;
      this.inAppBrowserRef = null;
      this.firstPageLoaded = false;

      var target = "_blank";
      var options = "location=no,hidden=yes,hardwareback=yes,clearcache=yes,clearsessioncache=yes";

      this.inAppBrowserRef = cordova.InAppBrowser.open(url, target, options);

      if (this.inAppBrowserRef) {
        this.inAppBrowserRef.addEventListener('loadstart', function (event) {
          _this12.onLoadStart(event);
        });
        this.inAppBrowserRef.addEventListener('loadstop', function (event) {
          _this12.onLoadStop(event);
        });
        this.inAppBrowserRef.addEventListener('loaderror', function (event) {
          _this12.onLoadError(event);
        });
        this.inAppBrowserRef.addEventListener('exit', function (event) {
          _this12.onExit(event);
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      IdleHandler.start();
      console.log('close');
      console.log(this.inAppBrowserRef);
      if (this.inAppBrowserRef !== null) {
        this.inAppBrowserRef.close();
        this.inAppBrowserRef = null;
        EmbeddedBrowser.active = null;
      }
    }
  }, {
    key: "onLoadStart",
    value: function onLoadStart(event) {
      console.log('onLoadStart');
      console.log(event);

      if (event.url.includes("/login")) {
        this.close();
        this.callbacks.loadError("NO LOGIN");
      } else if (!this.firstPageLoaded) {
        this.callbacks.loadStart(event);
      }
    }
  }, {
    key: "onLoadStop",
    value: function onLoadStop(event) {
      console.log('onLoadStop');
      console.log(event);

      if (this.inAppBrowserRef) {

        if (event.url.includes("close_mymobile")) {
          this.close();
          this.callbacks.loadStop(event);
        } else if (!this.firstPageLoaded) {
          this.firstPageLoaded = true;
          this.callbacks.loadStop(event);
          this.inAppBrowserRef.executeScript({ code: "var MYMOBILE_INTERVAL = setInterval( function(){ if( inMymobile ){ inMymobile(); clearInterval(MYMOBILE_INTERVAL) } } , 1000)" }, function (params) {
            console.log(params);
          });
          this.inAppBrowserRef.show();
        }
      }
    }
  }, {
    key: "onLoadError",
    value: function onLoadError(event) {
      console.log('onLoadError');
      console.log(event);

      if (!this.firstPageLoaded) {
        this.firstPageLoaded = true;
        this.callbacks.loadError(event);
        this.close();
      }
    }
  }, {
    key: "onExit",
    value: function onExit(event) {
      this.close();
    }
  }], [{
    key: "stop",
    value: function stop() {
      if (EmbeddedBrowser.active !== null) {
        EmbeddedBrowser.active.close();
      }
    }
  }]);

  return EmbeddedBrowser;
}();

EmbeddedBrowser.active = null;

function startLoadingSpinner() {
  $.mobile.loading("show", { html: $('<div class="ui-loader"><svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg></div>') });
}

function stopLoadingSpinner() {
  setTimeout(function () {
    $.mobile.loading("hide");
  }, 100);
}

function simpleAlert(title, message, elem) {
  if (inBrowser) {
    openMessagePopup(message, elem);
  } else {
    navigator.notification.alert(message, function (param) {}, title, $t("buttons.ok"));
  }
}

function initSosPage() {
  resetSosButtons();
  sosClearTimer();
  startSOS();
}

function resetSosButtons() {
  $("#send-sos-button").show();
  $("#cancel-sos-button").hide();
}

function openMyAssist() {

  startLoadingSpinner();

  var sApp = startApp.set({ /* params */
    "intentstart": "startActivityForResult",
    "intent": "com.tunstallhealthcare.myassist.LAUNCH_WITH_SOS",
    "flags": ["FLAG_ACTIVITY_NEW_TASK", "FLAG_ACTIVITY_CLEAR_TASK"]
  }, { /* extras */
    "com.tunstallhealthcare.myassist.ARG_STAY_ON_LOG_IN_REQUEST": { type: 'boolean', value: true },
    "com.tunstallhealthcare.myassist.ARG_REQUEST_TIME": { type: 'integer', value: new Date().getTime() }
  });

  sApp.start(function () {
    /* success */
    stopLoadingSpinner();
    console.log("OK");
  }, function (error) {
    /* fail */
    stopLoadingSpinner();
    navigator.notification.alert($t("myassist.messages.unable_to_launch"), function (param) {}, $t("myassist.title"), $t("buttons.ok"));
  });
}

var SOS_TIMER = null;

function sosStartTimer() {
  sosClearTimer();

  $("#send-sos-button").hide();
  $("#cancel-sos-button").show();

  SOS_TIMER = setTimeout(function () {
    resetSosButtons();
    stopLoadingSpinner();
    SOS_TIMER = null;
  }, 15000);
}

function sosClearTimer() {
  if (SOS_TIMER != null) {
    clearTimeout(SOS_TIMER);
    SOS_TIMER = null;
  }
}

function startSOS() {

  startLoadingSpinner();
  sosClearTimer();

  var sApp = startApp.set({ /* params */
    "intentstart": "sendOrderedBroadcast",
    "intent": "com.tunstallhealthcare.myassist.START_SOS",
    "results": ["com.tunstallhealthcare.myassist.SOS_SUCCESS"]
  });

  sApp.start(function (result) {
    /* success */

    if (result["com.tunstallhealthcare.myassist.SOS_SUCCESS"] == "true") {
      sosStartTimer();
    } else {
      stopLoadingSpinner();
      navigator.notification.alert($t("myassist.messages.unable_to_start"), function (param) {}, $t("myassist.title"), $t("buttons.ok"));
    }
  }, function (error) {
    /* fail */
    stopLoadingSpinner();
    navigator.notification.alert($t("myassist.messages.unable_to_start"), function (param) {}, $t("myassist.title"), $t("buttons.ok"));
  });
}

function cancelSOS() {

  startLoadingSpinner();
  sosClearTimer();
  resetSosButtons();

  var sApp = startApp.set({ /* params */
    "intentstart": "sendOrderedBroadcast",
    "intent": "com.tunstallhealthcare.myassist.CANCEL_SOS",
    "results": ["com.tunstallhealthcare.myassist.SOS_SUCCESS"]
  });

  sApp.start(function (result) {
    /* success */
    stopLoadingSpinner();
  }, function (error) {
    /* fail */
    stopLoadingSpinner();
  });
}

function scanIDCard() {
  if (mymobileConfig.anyline_ocr.enabled) {
    scanIDCardAnyLine();
  } else {
    scanIDCardGoogle();
  }
}

function scanIDCardAnyLine() {
  var params = [mymobileConfig.anyline_ocr.key, mymobileConfig.anyline_ocr.display, mymobileConfig.anyline_ocr.scan];
  cordova.exec(function (result) {
    console.log("ocr resuslt");
    console.log(result);
    if (result) {
      LoginPage.setScannedId(result.text);
    }
  }, function (error) {
    console.log("ocr error");
    console.log(error);
  }, "AnylineSDK", mymobileConfig.anyline_ocr.scanMode, params);
}

// start video capture
function scanIDCardGoogle() {

  var options = {};

  options.instructions = $t("scanner.camera_instructions");
  options.candidateExpression = mymobileConfig.id_scanner_candidateExpression;
  options.verifyExpression = mymobileConfig.id_scanner_verifyExpression;
  options.verifyChecksum = mymobileConfig.id_scanner_verifyChecksum;
  options.cameraDirection = mymobileConfig.id_scanner_options_cameraDirection;
  options.cancelText = $t("scanner.cancel_scan");
  options.switchText = $t("scanner.switch_cameras");

  IdScanner.startScan(options, function (result) {
    console.log(result);

    stopScan();
    if (result != "") {
      LoginPage.setScannedId(result);
    }
  }, function (error) {
    console.log(error);
  });
}

function stopScan() {

  IdScanner.stopScan(function (result) {
    console.log(result);
  }, function (error) {
    console.log(error);
  });
}